import React from "react";
import "./exam-submitted.css"; // Import the CSS file

const ExamSubmittedAlready = () => {
  return (
    <div className="Exam-Card-Box">
      <div className="exam-card">
      <h2 className="exam-title">Exam  Submitted</h2>
      <p className="exam-message">You have  submitted this exam. You cannot retake it.</p>

      <div className="exam-buttons">
         
        <button className="exam-button dashboard-btn" onClick={()=>window.location.href="/"}>
          Go to Dashboard
        </button>
      </div>
    </div>
    </div>
    
  );
};

export default ExamSubmittedAlready;
